import { DatePipe } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, first, map, Observable } from 'rxjs';
import { ResponseApi } from 'src/app/shared/interfaces/response-api';
import { AppToastService } from 'src/app/shared/services/app-toast.service';
import { AppConfigService } from 'src/environments/app-config.service';
import { HandleErrorService } from '../handle-error/handle-error.service';

@Injectable({
  providedIn: 'root'
})
export class WorkingDaysService {

  private environment: any
  private apiUrl: string;

  constructor(
    private readonly httpClient: HttpClient,
    private readonly datePipe: DatePipe,
    private readonly appConfig: AppConfigService,
    private readonly b3ToastService: AppToastService,
    private readonly handleErrorService: HandleErrorService
  ) {
    this.environment = this.appConfig.config;
    this.apiUrl = `${this.environment.apiIssuer}/working-days`
   }

  getWorkingDays(date: Date, dayQuantity:number = 5): Observable<string[]> {
    const startDate = this.datePipe.transform(date, 'yyyy-MM-dd') || ''
    const url = `${this.apiUrl}?startDate=${startDate}&dayQuantity=${dayQuantity}`

    return this.httpClient.get<ResponseApi<string>>(url).pipe(
      first(),
      map((response) => {
        const data = response.data['workingDates'];
        let workingDates: string[] = data;
        return workingDates;
      }),
      catchError((err) => {
        this.b3ToastService.show({
          status: 'warning',
          text: 'Não foi possível recuperar os dias disponíveis!'
        })
        this.handleErrorService.handleError(err)
        throw new Error(err)
      })
    )
  }
}
